import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';



import { ShFormDateComplexBaseComponent } from './base-complex/form-date-complex-base.component';
import { ShFormDateBaseComponent } from './base-simple/form-date-base.component';
import { ShFormDateComponent } from './main/form-date.component';

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, ShFormDateComponent, ShFormDateComplexBaseComponent, ShFormDateBaseComponent],
    exports: [ShFormDateComponent, ShFormDateComplexBaseComponent, ShFormDateBaseComponent],
    providers: [DatePipe]
})
export class ShFormDateModule {}

export { ShFormDateComplexBaseComponent } from './base-complex/form-date-complex-base.component';
export { ShFormDateBaseComponent } from './base-simple/form-date-base.component';
export { ShFormDateComponent } from './main/form-date.component';
